import React from "react";
import PropTypes from "prop-types";
import { Stack } from "@mui/material";
import {
  BaseDialogBox,
  BaseDrawer,
  DialogTitle,
  DialogContent,
  ActionBox,
  CancelButton,
  ConfirmButton,
  SingleActionButton,
} from "./Styled/DialogStyles";

const BaseDialog = ({
  open,
  onClose,
  type = 'modal',
  title,
  content,
  contentColor,
  actionType = 'double',
  leftButtonText = "취소",
  rightButtonText = "확인",
  singleButtonText = "확인",
  singleButtonDisabled = false,
  onLeftClick,
  onRightClick,
  onSingleClick,
  className,
  children,
  anchor = 'bottom',
}) => {
  // 바깥(배경) 클릭 시 닫기: onClose 우선, 없으면 취소/단일 버튼 핸들러 사용
  const handleBackdropClose = onClose ?? onLeftClick ?? onSingleClick;

  const renderActions = () => {
    if (actionType === 'none') return null;

    if (actionType === 'single') {
      return (
        <ActionBox>
          <SingleActionButton onClick={onSingleClick} disableRipple disabled={singleButtonDisabled}>
            {singleButtonText}
          </SingleActionButton>
        </ActionBox>
      );
    }

    return (
      <ActionBox>
        <CancelButton onClick={onLeftClick} disableRipple>
          {leftButtonText}
        </CancelButton>
        <ConfirmButton onClick={onRightClick} disableRipple className={className}>
          {rightButtonText}
        </ConfirmButton>
      </ActionBox>
    );
  };

  const renderContent = () => (
    <>
      <Stack gap={1}>
        {title && <DialogTitle>{title}</DialogTitle>}
        {content && <DialogContent color={contentColor}>{content}</DialogContent>}
      </Stack>
      {children}
      {renderActions()}
    </>
  );

  if (type === 'drawer') {
    return (
      <BaseDrawer anchor={anchor} open={open} onClose={handleBackdropClose}>
        {renderContent()}
      </BaseDrawer>
    );
  }

  return (
    <BaseDialogBox open={open} onClose={handleBackdropClose}>
      {renderContent()}
    </BaseDialogBox>
  );
};

BaseDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  type: PropTypes.oneOf(['modal', 'drawer']),
  title: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  contentColor: PropTypes.string,
  actionType: PropTypes.oneOf(['single', 'double', 'none']),
  leftButtonText: PropTypes.string,
  rightButtonText: PropTypes.string,
  singleButtonText: PropTypes.string,
  singleButtonDisabled: PropTypes.bool,
  onLeftClick: PropTypes.func,
  onRightClick: PropTypes.func,
  onSingleClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
  anchor: PropTypes.oneOf(['top', 'left', 'bottom', 'right']),
};

export default BaseDialog;
